<script setup lang="ts">
	import { computed } from 'vue'
	import { Activity, Archive, User, Users, List, Plug, Server, Bell, Boxes, MapPin, History, Code2, PhoneCall, Map, LineChart, CircuitBoard, Flag } from 'lucide-vue-next'

	const props = defineProps<{
		icon: string
	}>()

	const iconSize = 20

	const iconMap = computed<Record<string, any>>(() => ({
		user: User,
		users: Users,
		list: List,
		ws: Plug,
		comapp: Server,
		alerts: Bell,
		inventory: Boxes,
		mapmarker: MapPin,
		changelogs: History,
		admin: Code2,
		ipcalls: PhoneCall,
		traffic: Activity,
		yoctologs: Archive,
		featureflags: Flag,
		locations: Map,
		hub: CircuitBoard,
		graphs: LineChart,
	}))

	const resolvedIcon = computed(() => iconMap.value[props.icon] || null)
</script>

<template>
	<component :is="resolvedIcon" v-if="resolvedIcon" :size="iconSize" />
</template>
